import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { formatDate, sectionsPath } from '../../../utility/coachCertification'

import classes from './PriceCard.module.scss'
import buttonClasses from './Button.module.scss'

const PriceCardCertified = ({ certification }) => {
  const { t } = useTranslation()
  const { certified, enrollment } = certification
  const completed = enrollment?.status === 'completed'
  const earnedOn = certified?.issuedDate || enrollment?.completedAt
  const earned = earnedOn && t('portal.certification.priceCard.earned', { date: formatDate(earnedOn) })

  return (
    <div>
      <div className={classNames('d-flex align-items-center', classes.stateRow)}>
        <i className={classNames('fa fa-graduation-cap', classes.certifiedIcon)} aria-hidden='true' />
        <span className={classes.stateTitle}>{t('portal.certification.priceCard.certified', { level: certification.level })}</span>
      </div>
      {earned && <p className={classes.note}>{earned}</p>}
      {completed && (
        <>
          <Link to={sectionsPath(certification.id)} className={classNames('d-flex justify-content-center w-100 mb-3', buttonClasses.outline)}>
            {t('portal.certification.priceCard.review')}
          </Link>
          {enrollment.certificateUrl && (
            <p className='text-center mb-4'>
              <a href={enrollment.certificateUrl} target='_blank' rel='noopener noreferrer' className={classes.textLink}>
                <i className='fa fa-file-pdf-o mr-2' aria-hidden='true' />
                {t('portal.certification.priceCard.downloadCertificate')}
              </a>
            </p>
          )}
        </>
      )}
    </div>
  )
}

PriceCardCertified.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    level: PropTypes.number.isRequired,
    enrollment: PropTypes.shape({
      status: PropTypes.string.isRequired, completedAt: PropTypes.string, certificateUrl: PropTypes.string,
    }),
    certified: PropTypes.shape({ issuedDate: PropTypes.string }),
  }).isRequired,
}

export default PriceCardCertified
